import React from 'react';
import reform from 'components/Reform';
import Fieldset from 'components/Fieldset';
import Button from 'components/Button';
import FormError from 'components/FormError';

const ResetPasswordForm = reform({
  forceErrorsVisible: true
})(
  ({
    username,
    password,
    passwordConfirm,
    onSubmit,
    handleFocus,
    loading,
    formValid,
    errorMessage,
    handleChange
  }) => (
    <form name="resetPassword" className="resetPasswordform" onSubmit={onSubmit}>
      <Fieldset
        field={password}
        name="password"
        inputType="password"
        labelText="Password"
        autoComplete="new-password"
        onChange={handleChange}
        onFocus={handleFocus}
        hideAsterisk
      />
      <Fieldset
        field={passwordConfirm}
        name="passwordConfirm"
        inputType="password"
        labelText="Confirm password"
        autoComplete="new-password"
        onChange={handleChange}
        onFocus={handleFocus}
        hideAsterisk
      />
      <Fieldset
        field={username}
        name="username"
        inputType="text"
        labelText="Username"
        autoComplete="username"
        hideAsterisk
      />
      <div className="fieldset fieldset--fullflex">
        <Button
          disabled={!formValid}
          loading={loading}
          title="Reset password"
          buttonText="Reset password"
          type="submit"
        />
      </div>
      <FormError errorMessage={errorMessage} />
    </form>
  )
);

export default ResetPasswordForm;
